export const hostApi = process.env.REACT_APP_HOST_API;
export const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN;
export const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
export const auth0ExternalClientId = process.env.REACT_APP_AUTH0_EXTERNAL_CLIENT_ID;
export const auth0Audience = process.env.REACT_APP_AUTH0_AUDIENCE;
export const auth0Namespace = process.env.REACT_APP_AUTH0_NAMESPACE;
export const agreementDate = process.env.REACT_APP_AGREEMENT_DATE;
export const reportLimit = process.env.REACT_APP_REPORT_LIMIT;
